import { IDadataRepository } from 'ud-ui/components/dadata-address-autocomplete/domain';
import { DadataRepository } from './dadata.repository';

export const createDadataRepository = (): IDadataRepository => {
  return new DadataRepository('e2e2632d06e080aad5e8c1d5fd10056c0e08a341');
};
